export default __webpack_public_path__ + "static/media/h29koritu.bb7ced64.mp3";